import Vue from "vue";
import Goo from "@gooroo-life/goo-ui-vue";

Vue.use(Goo);
